import {useMemo} from 'react';

import {Icon, IconName} from 'components';

const icons: {[value: number]: IconName} = {
    0: 'wifi-off',
    1: 'wifi-0',
    2: 'wifi-25',
    3: 'wifi-50',
    4: 'wifi-75',
    5: 'wifi-100',
};

type Props = {
    value: number
};

export const NetworkQuality: React.FC<Props> = ({value}: Props) => {
    const iconName = useMemo(() => icons[value], [value]);
    if (!iconName) {
        return null;
    }
    return <Icon name={iconName} color={value === 0 ? 'alert' : 'default'} />;
};
